import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import headplaning from "../../../../services/headplaning.service";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import {
  Card,
  Button,
  Col,
  Row,
  Dropdown,
  Image,
  Container,
  Tabs,
  Tab,
  Form
} from "react-bootstrap";
import TableForm from "../../../../components/TableForm";
import ConfirmModal from "../../../../components/ConfirmModal";
import { getServiceRequest, addEditServiceRequest } from "../../../../commons/ServiceRequest";
import TechniciansService from "../../../../services/technician.service";
import TechnicianPlansService from "../../../../services/technicianplan.service";
import SequenceStatusService from "../../../../services/sequencestatus.service";
import DepartJobsService from "../../../../services/departjob.service";
import ReasonsService from "../../../../services/reasons.service";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import { formatInputDate } from "../../../../utils/Time";
import { formatDate } from "../../../../commons/FormatValue";
import handleChangeWebsiteTab from "../../../../commons/ChangeWebsiteTab";
import TableForm2s from "../../../../components/TableFormScrb";

export default function EditEventPlanningDetail() {
  const { id } = useParams();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const defaultDatas = [
    {
      Id: null,
      Job_Other_Id: 0,  // Text type
      Job_Type_Id: 0,
      Seq_Status_Id: null,
      Seq_Oth_No: null,  // Text type
      Com_Code: null,  // Text type
      Tech_Mas_ID: null,
      Tech_Mas_Name: null,
      Job_Type_Name: null,  // Text type
      Inform_Doc_No: null,
      Inform_Doc_Date: null,  // Text type
      Job_Cus_Date: null,  // Text type
      Ref_Doc_No: null,  // Text type
      Ref_Doc_Date: null,  // Text type
      Cus_Code: null,  // Text type
      Cus_Name: null,  // Text type
      Item_Code: null,  // Text type
      Job_Actual_Date: null
    }
  ];
  const [data, setData] = useState([]);
  const [dataModal, setDataModal] = useState({ Array: [] });
  const [validated, setValidated] = useState(false);
  const [tech, setTech] = useState([]);
  const [statusMas, setStatusMas] = useState([]);
  const [reasons, setReasons] = useState([]);
  const vPlanStatus = [
    {
      "Status": "OPEN", "Sts": "OPEN"
    }
    , {
      "Status": "CANCEL", "Sts": "CANCEL"
    }
    , {
      "Status": "CLOSED", "Sts": "CLOSED"
    }
    , {
      "Status": "ACCEPT", "Sts": "ACCEPT"
    }
  ];

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        EventPlanning: "หัวหน้าวางแผนงาน",
        EventplaningDetail: "ข้อมูลการวางแผน",
        EventplaningCalendar: "ปฏิทินงานช่าง"
      }
    });
  };

  const columns = [
    { name: "Job_Type_Name", label: "ประเภทงาน", readOnly: true, width: "180px", },
    {
      name: "Tech_Doc_Date",
      label: "วันที่วางแผน",
      readOnly: true
    },
    // {
    //   name: "Tech_Doc_No",
    //   label: "เลขที่วางแผน",
    //   readOnly: true
    // },
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      readOnly: true,
      width: "180px"
    },
    { name: "Cus_Code", label: "รหัสลูกค้า/สาขา", readOnly: true },
    { name: "Cus_Name", label: "ชื่อลูกค้า/สาขา", readOnly: true, width: "250px", showTooltip: true },
    {
      name: "Start_Date",
      label: "วันที่เริ่มงาน",
      format: (row) => row?.Start_Date ? formatDate(row?.Start_Date) : "",
      readOnly: true
    },
    {
      name: "End_Date",
      label: "วันที่เสร็จงาน",
      format: (row) => row?.End_Date ? formatDate(row?.End_Date) : "",
      readOnly: true
    },
    {
      name: "Job_Actual_Date",
      label: "วันที่เข้างานจริง",
      type: "date",
      // noneRequired: true
    },
    {
      name: "Tech_Mas_Id",
      label: "ช่างผู้ปฏิบัติงาน",
      type: "select",
      required: true,
      noneAsync: true,
      filterBy: ["Tech_Mas_Name"],
      width: "220px",
      options: initializeSetOption({
        key: "Id",
        label: "Tech_Mas_Name",
        dataset: tech
      })
    },
    {
      name: "Depart_St_Id",
      label: "สถานะงานช่าง",
      type: "select",
      width: "230px",
      required: true,
      noneAsync: true,
      filterBy: ["Depart_St_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Depart_St_Name",
        dataset: statusMas
      })
    },
    {
      name: "Reject_Reason",
      label: "เหตุผลที่ไม่รับงาน",
      // type: "select",
      showTooltip: true,
      readOnly: true,
      width: "180px",
    },
    {
      name: "Seq_St_Name",
      label: "สถานะใบสั่งงาน",
      readOnly: true
      // type: "select",
      // required: true,
      // noneAsync: true,
      // filterBy: ["Seq_St_Name"],
      // options: initializeSetOption({
      //   key: "Id",
      //   label: "Seq_St_Name",
      //   dataset: seqStsMas
      // })
    },
    // {
    //   name: "Plan_Status",
    //   label: "สถานะแผน",
    //   type: "select",
    //   required: true,
    //   noneAsync: true,
    //   filterBy: ["Status"],
    //   options: initializeSetOption({
    //     key: "Sts",
    //     label: "Status",
    //     dataset: vPlanStatus
    //   })
    // },
  ];

  const handleSubmit = async (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);
    if (dataCallback) {
      try {
        await handleSubmitPlanDts(dataCallback);
      } catch (error) {
        // Handle errors from handleSubmitPlanDts
        console.error(error);
      }
    }
    // navigate("/service_work/planning", {
    //   state: "EventplaningDetail"
    // });
  };

  const handleSubmitPlanDts = async (Plan) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianPlansService.editTechnicianPlans(id, Plan[0]),
      navigated: (navi) => navi && navigate("/service_work/planning", {
        state: { name: "EventplaningDetail" }
      })
    });
  };

  const pSetData = (vData) => {
    let a = { data: [vData] };
    const newArray = a.data.map((items) => ({
      Id: items.id,
      Depart_St_Id: items.DepartJob?.Id,
      Seq_No: items.SeqOthersJob?.Seq_Oth_No
        || items.SeqInstalljob?.seq_install_no
        || items.RepairJobs?.seq_repair_no,
      // Job_Type_Name: items.SeqOthersJob?.InformOtherJob?.JobType?.Job_Type_Name
      //   || items.SeqInstalljob?.InformInstallJobs?.JobType?.Job_Type_Name
      //   || items.RepairJobs?.job_type_items?.Job_Type_Name,
      Job_Type_Name: items.SeqOthersJob?.JobType?.Job_Type_Name
        || items.SeqInstalljob?.JobTypes?.Job_Type_Name
        || items.RepairJobs?.JobType?.Job_Type_Name,
      // Tech_Doc_No: items.Tech_Doc_No,
      Tech_Doc_Date: formatInputDate(items.tech_doc_date, "Local").date,
      Job_Actual_Date: formatInputDate(items.job_actual_date, "Local").date,
      // Tech_Mas_Name: items.Technician.Tech_Mas_Name,
      Tech_Mas_Id: items.Technician?.Id,
      // Depart_St_Name: items.DepartJob?.Depart_St_Name,
      Seq_St_Name: state?.Seq_Status_Name || items.SequneceStatus?.Seq_St_Name,
      Cus_Code: items.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Code
        || items.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Code
        || items.RepairJobs?.InformInstallJobs?.Customer?.Cus_Code
        || state?.Cus_Code,
      Cus_Name: items.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Name
        || items.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Name
        || items.RepairJobs?.InformInstallJobs?.Customer?.Cus_Name
        || state?.Cus_Name,
      Plan_Status: items.Plan_Status,
      Job_Cus_Date: formatInputDate(items.SeqOthersJob?.InformOtherJob.Job_Cus_Date, "Local").date,
      Start_Date: formatInputDate(
        items.SeqInstalljob?.job_start_date
        || items.RepairJobs?.job_start_date
        // || items.SeqOthersJob?.InformOtherJob.Job_Cus_Date
        , "Local").date,
      End_Date: formatInputDate(
        items.SeqInstalljob?.job_end_date
        || items.RepairJobs?.job_end_date
        // || items.SeqOthersJob?.InformOtherJob.Job_Cus_Date
        , "Local").date,
      Reject_Reason: items.TechnicianReceive?.length ? items.TechnicianReceive[0]?.Reject_Reason : ""
    }));
    setData(newArray);
  };

  useEffect(() => {
    setTimeout(() => handleChangeTab(state?.name || "EventplaningDetail"), 300);
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianPlansService.getTechnicianPlans(id),
      callback: (res) => pSetData(res)
    });
  }, [id, state]);

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: TechniciansService.getAllTechnicians(),
      callback: (res) => {
        setTech(res);
      }
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: DepartJobsService.getAllDepartJobs(),
      callback: (res) => setStatusMas(res)
    });

    // getServiceRequest({
    //   showAlert,
    //   setLoading,
    //   serviceRequest: ReasonsService.getAllReasons(),
    //   callback: (res) => setReasons(res)
    // });
  }, []);

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state?.name || "EventplaningDetail"}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="EventPlanning" title="หัวหน้าวางแผนงาน" disabled>
          </Tab>
          <Tab eventKey="EventplaningDetail" title="ข้อมูลการวางแผน">
            <Form noValidate validated={validated} onSubmit={handleValidated}>
              <CardDisplayComponent
                header={{ title: { text: "รายละเอียดการแก้ไข" } }}
                body={{
                  element: (
                    <TableForm2s
                      data={data}
                      defaultData={defaultDatas[0]}
                      columns={columns}
                      pending={loading}
                      editForm={true}
                      pagination={false}
                      onChangeCallback={(newData) => {
                        // console.log(newData[0])
                        const aForSave = newData.map((item) => ({
                          //Id: item.Id,
                          job_actual_date: item.Job_Actual_Date,
                          depart_st_id: Number(item.Depart_St_Id),
                          tech_mas_id: Number(item.Tech_Mas_Id),
                          // Tech_Mas_Name: "",
                        }));
                        setData(newData);
                        setDataModal({ Array: aForSave });
                      }}
                    />
                  )
                }}
                footer={{
                  className: "text-end",
                  element: (
                    <>
                      <Button
                        type="submit"
                        variant="success"
                        className="me-2 px-5 py-2 text-dark rounded-pill"
                      >
                        บันทึกข้อมูล
                      </Button>
                      <ConfirmModal
                        show={showModal}
                        data={dataModal.Array}
                        content={"add"}
                        onSubmitCallback={handleSubmit}
                      />
                      <Button
                        variant="outline-secondary"
                        className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                        onClick={() =>
                          navigate("/service_work/planning", {
                            state: { name: "EventplaningDetail" }
                          })
                        }
                      >
                        ย้อนกลับ
                      </Button>
                    </>
                  )
                }}
              />
            </Form>
          </Tab>
          <Tab eventKey="EventplaningCalendar" title="ปฏิทินงานช่าง" disabled>
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
